<template>
  <div class="download-magazine-edition default-page">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="container-fluid">
              <div class="row">
                <div class="col-12" style="text-align: center">
                  <h5>Se o download do arquivo não foi feito siga as instruções abaixo</h5>
                </div>
                <div class="col-12" style="margin-top: 18px">
                  <ul>
                    <li>
                      No final da barra de endereço, clique no ícone do bloqueador de pop-ups
                      <img src="@/assets/icons/pop-up-block.jpeg" style="width:20px" />.
                    </li>
                    <li>Clique no link referente à janela pop-up que você deseja ver.</li>
                    <li>Para ver sempre os pop-ups do site, selecione "Sempre mostrar pop-ups desse site." O site será adicionado à lista de exceções, a qual pode ser gerenciada na caixa de diálogo "Configurações de conteúdo".</li>
                  </ul>
                </div>
                <div class="col-12">
                  <a :href="link" target="_blank" rel="noopener noreferrer">
                    <button class="btn btn-primary float-right">Baixar arquivo</button>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "@/api/axios";
import Swal from "sweetalert2";
import { bus } from "@/main";

export default {
  name: "download-magazine-edition",
  data() {
    return {
      ref: "",
      link: ""
    };
  },
  mounted() {
    this.ref = this.$route.query.ref;
    this.downloadEdition();
  },
  methods: {
    downloadEdition: function() {
      bus.$emit("changeLoading", true);
      axios
        .get(
          `${process.env.VUE_APP_API_HOST}/api/magazine_edition_download/${this.ref}`
        )
        .then(response => {
          this.link = response.data;
          window.open(response.data);
          bus.$emit("changeLoading", false);
        });
    }
  }
};
</script>

<style lang="scss">
@import "@/styles/General.scss";
</style>